import { render } from "./App-mobile.vue?vue&type=template&id=4286889a&scoped=true"
import script from "./App-mobile.vue?vue&type=script&lang=js"
export * from "./App-mobile.vue?vue&type=script&lang=js"

import "./App-mobile.vue?vue&type=style&index=0&id=4286889a&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4286889a"]])

export default __exports__